import useSWR from "swr"
import {API_PROJECTS} from "../constants/apiUrls"

export default function useTries(projectId) {
    const {data, mutate, error} = useSWR(`${API_PROJECTS}/${projectId}/tries`)
    return {
        tries: data,
        mutateTries: mutate,
        isLoadingTries: !error && !data,
        isErrorTries: error
    }
}